import { IData } from './../interfaces/idata';
import { Injectable } from '@angular/core';
import { Subject } from 'rxjs/Subject';

@Injectable()
export class ValidationService {
  public static Messages = {
    Generica: {
      MSG_GENERICA_ERRO_INESPERADO_HTTP: 'Erro inesperado! Favor contate o administrador do sistema.',
      MSG_DR10_SEL_REGISTRO_TIPO_PRESTACAO_CONTA: 'Selecione um registro cujo tipo seja prestação de contas.',
      MSG_DR10_CONFIRMACAO_APROVACAO_SOLICITACAO_DESEMBOLSO: 'Confirma a aprovação da solicitação?',
      MSG_DR10_ATUALIZAR_PAGAMENTO_COM_SOLICITACAO_DESEMBOLSO_APROVADO: 'Não é possível atualizar pagamentos de uma solicitação aprovada.',
      MSG_DR10_ASSOSSIAR_PAGAMENTO_TIPO_INVALIDO_SOLICITACAO_DESEMBOLSO:
        'Não é permitido associar pagamentos para este tipo de solicitação.',
      MSG_DR10_SEL_REGISTRO_SOLICITACAO_DESEMBOLSO_PARA_IMPRESSAO: 'Selecione uma Solicitação de Desembolso para impressão.'
    },
    Negocio: {
      MN0002: 'Selecione uma atividade para associar as aquisições.',
      MN0036: 'Código destinação de recursos já cadastrado anteriormente.',
      MN0055: 'O valor do componente não permite uma atividade com este valor.',
      MN0061: 'Aquisição (ões) associada (s) com sucesso.',
      MN0062: 'Deve ser informada pelo menos uma aquisição para associação.',
      MN0099: 'O tipo de aquisição {aquisicao} da categoria {categoria} encontra-se em duplicidade para essa Atividade.',
      MN0128: 'Não foi possível alterar a solicitação de desembolso. Apenas a última solicitação aprovada pode ser alterada.',
      MN0129: 'Não foi possível alterar a solicitação de desembolso. Apenas solicitação aberta pode ser alterada.',
      MN0040: 'Data inválida.',
      MN0065: 'A data início deve ser inferior a data término.',
      MN0066: 'Item do PA já associado ao contrato.',
      MN0075: 'Item do PA incluído com sucesso.',
      MN0068: 'Planejamento dos pagamentos do contrato atualizado com sucesso.',
      MN0072: 'Aditivo (s) do contrato atualizado (s) com sucesso.',
      MN0132: 'O valor BID do componente não permite uma atividade com aquisições com este valor.',
      MN0142: 'Não é possível adicionar, já existe aquisição adicionada com esta descrição para esta categoria.',
    }
  };

  public static verificaDataInvalida(data: IData) {
    const strRegex = ['(^(((0[1-9]|1[0-9]|2[0-8])[/](0[1-9]|1[012]))|((29|30|31)',
      '[/](0[13578]|1[02]))|((29|30)[/](0[4,6,9]|11)))[/](19|[2][0])([0-7]\\d$))',
      '|(^29[/]02[/](19|[2][0])(00|04|08|12|16|20|24|28|32|36|40|44|48|52|56)$)'].join('');

    const regex = new RegExp(strRegex);

    if (data === undefined || data === null) {
      return false;
    }

    if (this.dataMaximaInvalida(data.day, data.month, data.year)) {
      return true;
    }


    if (data.year == null || data.year === undefined) {

      const year = Number.parseInt(data.toString().substring(6, 10));
      const month = Number.parseInt(data.toString().substring(3, 5));
      const day = Number.parseInt(data.toString().substring(0, 2));

      if (this.dataMaximaInvalida(day, month, year)) {
        return true;
      }

      const strSemIdata = data.toString();
      if (!((regex.test(strSemIdata)) && strSemIdata !== '')) {
        return true;
      }

    }
    else {

      const strData = `${data.day.toString().padStart(2, '0')}/${data.month.toString().padStart(2, '0')}/${data.year.toString()}`;
      if (!((regex.test(strData)) && strData !== '')) {
        return true;
      }
    }

    return false;
  }

  private static dataMaximaInvalida(day, month, year): boolean {
    if (year === 2079) {

      if (month > 6) {
        return true;
      }
      else if (month === 6 && day > 6) {
        return true;
      }

    }
    return false;
  }

  public validationMessages = {
    Geral: {
      required: '{controlDescription} obrigatório(a).'
    },
    Cadastro: {
      Programa: {}
    }
  };

  public resetForm: Subject<boolean> = new Subject<boolean>();
  public validationMessagesForm: any;

  public getValidatorErrorMessage(controlName: string, validatorName: string, validatorValue?: any) {
    let config = this.validationMessagesForm[controlName];

    if (config === undefined) {
      config = this.validationMessages.Geral;
    }

    return config[validatorName];
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/service/ValidationService.ts